var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sdr-box" }, [
    _c("h5", { staticClass: "box-title" }, [
      _vm._v(_vm._s(_vm.aboutsundair[_vm.getCurrentLocale])),
    ]),
    _vm._v(" "),
    _c("p", {
      domProps: {
        innerHTML: _vm._s(_vm.aboutsundairtext[_vm.getCurrentLocale]),
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }